export default __webpack_public_path__ + "static/media/highway.0d5d3930.png";